<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows p-datatable-no-header">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-end">
            <div class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
          </div>
        </div>
        <p-table [(first)]="first" [(rows)]="rows" [paginator]="true"
                 [value]="firmwareProcedures" [responsive]="true" [rowsPerPageOptions]="[10,25,50]"
                 [totalRecords]="totalProcedures" styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{'attribute.serialNumber' | transloco}}</th>
              <th scope="col">{{'attribute.firmwareType' | transloco}}</th>
              <th scope="col">{{'attribute.firmwareVersion' | transloco}}</th>
              <th scope="col">{{'attribute.state' | transloco}}</th>
              <th scope="col">{{'attribute.date' | transloco}}</th>
              <th scope="col">{{'attribute.organization' | transloco}}</th>
            </tr>
          </ng-template>
          <ng-template let-procedure pTemplate="body">
            <tr *ngIf="!loadingProcedures">
              <td>
                <span class="p-column-title bold">{{'attribute.serialNumber' | transloco}}</span>
                <a [routerLink]="['/machines', procedure.machine.machineUuid, 'details']">{{procedure.machine.serial}}</a>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.firmwareType' | transloco}}</span>
                <span *ngIf="procedure.firmwareType === FirmwareType.FIRMWARE_IOT">{{ 'attribute.firmwareIot' | transloco }}</span>
                <span *ngIf="procedure.firmwareType === FirmwareType.FIRMWARE_MACHINE_ECU">{{ 'attribute.firmwareEcu' | transloco }}</span>
                <span *ngIf="procedure.firmwareType === FirmwareType.FIRMWARE_MACHINE_ELEVATOR">{{ 'attribute.firmwareElevator' | transloco }}</span>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.firmwareVersion' | transloco}}</span>
                {{procedure.targetVersion}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.state' | transloco}}</span>
                <p-tag *ngIf="procedure.state === FirmwareProcedureState.QUEUED" styleClass="queued m-0"
                       value="{{ 'ota.'+ procedure.state | transloco }}"></p-tag>
                <p-tag *ngIf="procedure.state === FirmwareProcedureState.STARTED" styleClass="started m-0"
                       value="{{ 'ota.'+ procedure.state | transloco }}"></p-tag>
                <p-tag *ngIf="procedure.state === FirmwareProcedureState.FINISHED" styleClass="finished m-0"
                       value="{{ 'ota.'+ procedure.state | transloco }}"></p-tag>
                <p-tag *ngIf="procedure.state === FirmwareProcedureState.FAILED" styleClass="failed m-0"
                       value="{{ 'ota.'+ procedure.state | transloco }}"></p-tag>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.date' | transloco}}</span>
                {{procedure.date | date:'medium': authGuard.getOffset(): authGuard.getLanguage() }}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.organization' | transloco}}</span>
                {{procedure.organization.name}} ({{procedure.organization.orgCode}})
              </td>
            </tr>
            <tr *ngIf="loadingProcedures">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="totalProcedures == 0"
                 class="flex align-items-center justify-content-between">{{'pagination.empty' | transloco}}</div>
            <div *ngIf="totalProcedures > 0" class="flex align-items-center justify-content-between">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalProcedures ? totalProcedures : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalProcedures}}
              {{(totalProcedures > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
    <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
    <div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="serialNumber">{{'attribute.serialNumber' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <input [(ngModel)]="currentFilters.serialNumber" (keyup.enter)="filtersVisible = false; applyFilters()"
                 pInputText class="w-full" id="serialNumber" type="text">
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="firmwareType">{{'attribute.firmwareType' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <p-multiSelect [(ngModel)]="currentFilters.firmwareTypes" [placeholder]="'select.generic' | transloco"
                         [options]="firmwareTypeOptions" [filter]="true" filterBy="label" display="chip" appendTo="body" styleClass="w-full"
                         optionLabel="label" optionValue="value" id="firmwareType"></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="targetVersion">{{'attribute.firmwareVersion' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <input [(ngModel)]="currentFilters.targetVersion" (keyup.enter)="filtersVisible = false; applyFilters()"
                 pInputText class="w-full" id="targetVersion" type="text">
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="state">{{'attribute.state' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <p-multiSelect [(ngModel)]="currentFilters.states" [placeholder]="'select.generic' | transloco"
                         [options]="stateOptions" [filter]="true" filterBy="label" display="chip" appendTo="body" styleClass="w-full"
                         optionLabel="label" optionValue="value" id="state"></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="range">{{'attribute.date' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <p-calendar [(ngModel)]="rangeDates" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                      [yearNavigator]="true" [yearRange]="availableYearRange" [firstDayOfWeek]="1" styleClass="w-full"
                      appendTo="body" selectionMode="range" dateFormat="dd/mm/yy" id="range" inputId="range"
                      [placeholder]="'select.dateRange' | transloco"></p-calendar>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="organization">{{'model.organization' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <p-treeSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco"
                        [propagateSelectionUp]="false" [propagateSelectionDown]="false" display="chip" appendTo="body"
                        [options]="hierarchy" [metaKeySelection]="false" selectionMode="checkbox" id="organization">
          </p-treeSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="organizationCode">{{'model.organizationCode' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <p-multiSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco"
                         [filter]="true" display="chip" styleClass="w-full" appendTo="body" [options]="organizationCodes"
                         id="organizationCode"></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <p-button type="button" (onClick)="filtersVisible = false; applyFilters()"
                  label="{{'common.filter' | transloco}}" styleClass="p-button-primary mx-2 mt-2" [disabled]="!(
                  currentFilters.serialNumber ||
                  currentFilters.firmwareTypes ||
                  currentFilters.targetVersion ||
                  currentFilters.states ||
                  rangeDates ||
                  (currentFilters.from &&
                  currentFilters.until) ||
                  organizations)">
        </p-button>
        <p-button type="button" (click)="resetFilters(); filtersVisible = false; applyFilters()"
                  label="{{'common.clear' | transloco}}" styleClass="p-button-danger"></p-button>
      </div>
    </div>
  </p-sidebar>
</div>
